import { createBtn, createFragment, createEl, createElWithText, createBtnWithSpinner } from "../../../helpers/dom-creators.js";
import { $ } from "../../../helpers/dom-selectors.js";
import emitGlobalFormEventWithData from "../../../helpers/form-events.js";
import Overlay from "../overlay.js";
export default function makeForms({ forms, overlayEl, entity, events, action }) {
    let initialized = false;
    let DELETE_PROMPT;
    const FORMS = [];
    return Object.freeze({
        init,
        update,
        add,
        remove,
        validateForm,
        getById,
        submit
    });
    function _findByIndex(index) {
        return FORMS.find(form => form.id === index);
    }
    function getById(index) {
        const form = _findByIndex(index);
        if (!form)
            return null;
        return { form: form.form, submitBtn: form.submitBtn };
    }
    function init() {
        if (initialized)
            return;
        DELETE_PROMPT = new Overlay(overlayEl);
        for (let i = 0; i < forms.length; i++) {
            FORMS.push(_newForm(forms[i], i));
            _addListeners(FORMS[i]);
        }
        initialized = true;
    }
    // ---------- ADD NEW FORM
    function _newForm(formEl, i) {
        return {
            form: formEl,
            id: i,
            formId: formEl.getAttribute('data-id'),
            deleteBtn: $(formEl, '.delete-btn')[0],
            submitBtn: $(formEl, '.submit-btn')[0]
        };
    }
    function add() {
        const lastIndex = FORMS.length - 1;
        const origForm = FORMS[lastIndex].form;
        const newForm = origForm.cloneNode(true);
        const newFormObj = _newForm(newForm, FORMS[lastIndex].id + 1);
        _resetForm(newFormObj);
        _changeSubmitBtnText(newFormObj.submitBtn, `Add ${entity}`);
        _hideDeleteBtn(newFormObj.deleteBtn);
        _addListeners(newFormObj);
        FORMS.push(newFormObj);
        origForm.after(newForm);
        return newFormObj.id;
    }
    function _addListeners(formObj) {
        formObj.form.addEventListener('submit', (e) => {
            e.preventDefault();
            _onFormSubmit(formObj);
        });
        formObj.deleteBtn.addEventListener('click', (e) => _onDelete(formObj));
    }
    function _resetForm(formObj) {
        const { form } = formObj;
        formObj.formId = null;
        form.removeAttribute('data-id');
        form.removeAttribute('data-src');
        const inputs = $(form, '.input-fields');
        const checkBoxes = $(form, `input[type="checkbox"]`);
        checkBoxes.forEach(checkbox => checkbox.checked = false);
        const duplicables = $(form, '.duplicable');
        for (let i = 1; i < duplicables.length; i++) {
            duplicables[i].remove();
        }
        inputs.forEach(input => {
            input.value = '';
            input.removeAttribute('value');
            input.innerHTML = '';
        });
    }
    function _changeSubmitBtnText(submitBtn, text) {
        const buttonText = $(submitBtn, 'span')[0];
        buttonText.innerText = text;
    }
    function _hideDeleteBtn(deleteBtn) {
        deleteBtn.classList.add('no-display');
    }
    // ---------- ON FORM SUBMIT
    function submit(index) {
        const form = _findByIndex(index);
        if (!form)
            return;
        _onFormSubmit(form);
    }
    function _onFormSubmit(formObj) {
        const { id, formId, form, submitBtn } = formObj;
        if (!formId) {
            emitGlobalFormEventWithData('form-created', { id, form, submitBtn });
            return;
        }
        emitGlobalFormEventWithData('form-updated', { index: id, id: formId, form, submitBtn });
    }
    function update(index, formId) {
        const form = _findByIndex(index);
        if (!form)
            return;
        form.formId = formId;
        _changeSubmitBtnText(form.submitBtn, 'Update');
        form.deleteBtn.classList.remove('no-display');
    }
    function validateForm(index) {
        const formObj = _findByIndex(index);
        if (!formObj)
            return;
        let isValid = true;
        const inputs = $(formObj.form, '.input-fields');
        inputs.every(input => {
            if (!input.checkValidity()) {
                input.focus();
                isValid = false;
                return false;
            }
            return true;
        });
        return isValid;
    }
    // ---------- DELETE FORM HANDLING
    function remove(id) {
        const formIndex = FORMS.findIndex(form => form.formId === id);
        if (formIndex === -1)
            return;
        if (FORMS.length === 1)
            events.emit(action); //avoid having no forms to clone
        FORMS[formIndex].form.remove();
        FORMS.splice(formIndex, 1);
    }
    function _onDelete(formObj) {
        if (!formObj.formId)
            return;
        _renderDeletePrompt(formObj.formId);
    }
    function _renderDeletePrompt(id) {
        const confirmBtn = createBtnWithSpinner('btns submit-btn', { type: 'button', text: 'Yes', title: 'Yes' });
        const cancelBtn = createBtn('btns submit-btn error-btn', { type: 'button', text: 'No', title: 'No' });
        const form = createEl('form', 'flex-container flex-center prompt-btns');
        form.append(confirmBtn, cancelBtn);
        const fragments = [
            createElWithText('h1', 'text-center', `Delete ${entity}`),
            createElWithText('p', 'text-center', `Are you sure you want to delete this ${entity.toLowerCase()}?`),
            form
        ];
        const fragment = createFragment(fragments);
        DELETE_PROMPT.render(fragment);
        confirmBtn.addEventListener('click', (e) => {
            emitGlobalFormEventWithData('form-deleted', {
                id,
                form,
                submitBtn: confirmBtn
            });
        });
        cancelBtn.addEventListener('click', (e) => DELETE_PROMPT.hide());
    }
}
